/**
 * Shared brand tokens for both faces of the site (agency + professional).
 * Values are taken from build/Geekcow-Website.svg so the code and the design
 * stay in sync — change them here, not inline in components.
 */
export const BRAND = {
  bg: "#e7f1f1",
  ink: "#141414",
  muted: "#666666",
  navy: "#003e5b",
  green: "#01e12d",
  greenBright: "#10fd02",
  yellow: "#ffc803",
  red: "#f42536",
  blue: "#256af4",
  /** Deep indigo used for the service pills in OurServicesSection.svg. */
  indigo: "#030155",
  teal: "#22c365",
  card: "#ffffff",
} as const;

/**
 * The two faces have two different LinkedIn identities:
 * `linkedin` is Olga's personal profile (the professional face),
 * `linkedinCompany` is the studio page (the agency face). Do not mix them —
 * the agency should never link a visitor to a personal profile, and vice versa.
 */
export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/geekcow/",
  linkedin: "https://www.linkedin.com/in/olgamolinaleche/",
  linkedinCompany: "https://www.linkedin.com/company/geekcow-creative-studio/",
  github: "https://github.com/omleche",
  dribbble: "https://dribbble.com/Molina-Leche",
  behance: "https://www.behance.net/olgamolinaleche",
} as const;

/** Google Calendar booking link, already used by ContactCTA. */
export const BOOKING_URL = "https://calendar.app.google/C7xfS8XtMoLKmnd86";

/** Legal identity — shown in both footers. */
export const LEGAL = {
  entity: "GeekCow Creative Studio",
  form: "sole trader established in Weesp, Netherlands",
  kvk: "73006637",
} as const;
